/* ==========================================================================
   Gutsi - homepage hero, background video timeline
   Loaded from snippets/stylesheets.liquid with defer.

   THE TWO NUMBERS THAT MATTER ARE AT THE TOP OF THE FUNCTION BELOW.

     HOLD_SECONDS   still photo on screen before the video starts
     PLAY_SECONDS   seconds of footage before it cuts back to the still

   Current: 6 seconds of still, 8 seconds of video, then the still for the
   rest of the visit. Desktop only - the section hides the video below 901px,
   so phones and tablets never see it.

   ==========================================================================
   WHY THE TIMING LIVES HERE AND NOT IN THE THEME SETTINGS

   The section has "Video starts after" and "Video cuts back to photo at"
   sliders, and they still exist - but they are stored in templates/index.json,
   which is 49KB, and themeFilesUpsert has no partial write. Retiming the hero
   therefore cost a 49KB rewrite each time, and it was retimed four times in
   one afternoon. Both numbers now live in this file instead.

   Those sliders are consequently IGNORED. index.json still reads start 0 /
   end 30; treat that as a dormant safety envelope, not the truth. If you want
   the sliders back in charge, delete this file and its <script> tag in
   snippets/stylesheets.liquid, then set them properly.

   Also worth knowing: the section's own timings are measured from PAGE LOAD,
   not from when the clip actually starts. PLAY_SECONDS here is measured from
   the `playing` event, so it is a true eight seconds of footage whether the
   visitor is on fibre or on a train.
   ========================================================================== */

(function () {
  var HOLD_SECONDS = 6;
  var PLAY_SECONDS = 8;
  var FADE_MS = 900;

  function setUpHeroVideo() {
    var video = document.querySelector('.gutsi-hero__bg-video');
    if (!video) return;

    var showing = false;
    var flipped = false;
    var timerStarted = false;

    video.loop = false;

    /* ----------------------------------------------------------------------
       Hold the still.

       The section arms the video on `canplay` by setting style.animation to a
       fade-in plus a fade-out, and calling play(). That can happen before or
       after this script runs, so the hold cannot rely on ordering - it has to
       be able to override the section at any point.

       An inline !important is what does it. CSS animations sit above normal
       declarations in the cascade but BELOW !important ones, so an inline
       important opacity pins the video hidden no matter what animation the
       section has running.

       The pause covers the other half. The `play` listener catches the
       section's call when it comes later; the immediate pause() catches the
       case where the section already armed before this script ran, which does
       happen and otherwise leaves the clip playing unseen behind the still,
       burning bandwidth for the whole hold.
       ---------------------------------------------------------------------- */
    video.style.setProperty('opacity', '0', 'important');
    try { video.pause(); } catch (e) {}

    video.addEventListener('play', function () {
      if (!showing) {
        try { video.pause(); } catch (e) {}
      }
    });

    /* Two steps, one task apart: clear the section's animation, then set the
       target opacity so the transition has a start value to move from.

       setTimeout and NOT requestAnimationFrame. rAF callbacks do not run while
       the page is hidden, so on a background tab the fade never fired and the
       video stayed invisible - caught in testing on 9 Sep 2026. A timeout runs
       either way, and the visitor sees the correct state when they come back. */
    function fadeTo(value, easing) {
      video.style.animation = 'none';
      setTimeout(function () {
        video.style.transition = 'opacity ' + FADE_MS + 'ms ' + easing;
        video.style.setProperty('opacity', value, 'important');
      }, 30);
    }

    /* Cut to the still. Pausing afterwards matters: without it the clip keeps
       decoding behind the photograph for the rest of its length. */
    function flipToStill() {
      if (flipped) return;
      flipped = true;

      fadeTo('0', 'ease-out');

      setTimeout(function () {
        try { video.pause(); } catch (e) {}
      }, FADE_MS + 200);
    }

    function showVideo() {
      showing = true;
      try { video.currentTime = 0; } catch (e) {}

      fadeTo('1', 'ease-in');

      var p = video.play();
      if (p && p.catch) p.catch(function () {});

      /* Backstop. Everything below keys off `playing`, which does not fire if
         autoplay is refused - and a refused autoplay would otherwise leave a
         frozen first frame sitting over the still for the rest of the visit.
         A few seconds of slack so a slow start is not cut short. */
      setTimeout(flipToStill, (PLAY_SECONDS + 4) * 1000);
    }

    /* `playing` fires on the first frame actually shown, and again after any
       stall recovers - hence the latch, so PLAY_SECONDS is measured from the
       start of playback and is not restarted by a buffering hiccup. */
    video.addEventListener('playing', function () {
      if (!showing || timerStarted) return;
      timerStarted = true;
      setTimeout(flipToStill, PLAY_SECONDS * 1000);
    });

    /* Safety net: if a clip shorter than PLAY_SECONDS is ever swapped in, cut
       when it runs out rather than holding a frozen last frame. */
    video.addEventListener('ended', flipToStill);

    setTimeout(showVideo, HOLD_SECONDS * 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setUpHeroVideo);
  } else {
    setUpHeroVideo();
  }
})();
